<template>
  <div class="flex flex-col flex-row gap-8 w-full items-center">
    <img v-if="img"
      :src="'/img/' + img"
      :alt="title"
      class="rounded-xl h-auto object-contain shadow-lg"
      :class="[imgLeft ? 'order-1' : 'order-2', `w-[${imgWidth}px]`]"
      loading="lazy"
    />
    <div class=" w-full text-left" :class="imgLeft ? 'order-2' : 'order-1'">
      <h2 class="text-2xl font-bold mb-2 flex" v-html="title"></h2>
      <p class="text-gray-600" v-html="description"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeatureBlock',
  props: ['img', 'title', 'description', 'imgLeft', 'imgWidth'],
}
</script>